<template>
  <v-list flat dense three-line>
    <v-progress-linear
      indeterminate
      color="primary"
      :active="activeBar"
    ></v-progress-linear>
    <template v-for="item in items">
      <v-divider color="primary" :key="item.header"> </v-divider>
      <v-list-item :key="item.date">
        <v-list-item-avatar>
          <v-btn color="primary" fab>SCT</v-btn>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-html="item.header"></v-list-item-title>
          <v-list-item-subtitle v-html="item.msg"></v-list-item-subtitle>
          <v-subheader v-html="item.date"></v-subheader>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { db } from "@/Firebase";
import { functions } from "@/Firebase";

export default {
  name: "Message",

  data() {
    return {
      activeBar: true,
      items: []
    };
  },
  mounted() {
    let notifyRef = db
      .collection("notification")
      .doc(this.$store.getters.userId);
    notifyRef
      .collection("1")
      .orderBy("date", "desc")
      .limit(5)
      .get()
      .then(snapshot => {
        let i = 0;
        snapshot.forEach(doc => {
          this.items.push(doc.data());
          this.items[i].date = this.items[i].date.toDate();
          i++;
        });
        this.activeBar = false;
      })
      .catch(function() {});
    if (!this.$store.state.notifyStatus) {
      var changeNotificationStatus = functions.httpsCallable(
        "changeNotificationStatus"
      );
      changeNotificationStatus({
        uid: this.$store.state.userId,
        read: true
      });
    }
  }
};
</script>
